<template>
  <div v-if="currentProfil">
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row justify-content-lg-center">
                  <div class="col-md-6 col-lg-2">
                    <div class="form-group">
                      <label for="date"
                        >Date d'évaluation
                        <span class="text-danger">*</span></label
                      >
                      <date-picker
                        v-model="form.date"
                        name="date"
                        placeholder="Date d'évaluation"
                        type="date"
                        lang="fr"
                        format="DD/MM/YYYY"
                        value-type="DD/MM/YYYY"
                      ></date-picker>
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('date'),
                        }"
                        type="hidden"
                      />
                      <has-error :form="form" field="date"></has-error>
                    </div>
                  </div>

                  <div class="col-md-6 col-lg-4">
                    <div class="form-group">
                      <label for="checklist"
                        >Fiche d'évaluation
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        id="checklist"
                        :options="checklists"
                        :reduce="(checklist) => checklist.uuid"
                        v-model="form.checklist"
                        placeholder="Fiche d'évaluation"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune données </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="checklist"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <input
                        type="hidden"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('checklist'),
                        }"
                      />
                      <has-error :form="form" field="checklist"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="form.item_lists.length > 0" class="mt-n4">
          <b-alert
            :show="itemListErrorMessage !== null"
            dismissible
            variant="danger"
          >
            <span v-html="itemListErrorMessage"></span>
          </b-alert>

          <div class="row mt-4">
            <div class="col-md-12">
              <table class="table bg-white">
                <thead>
                  <tr>
                    <th scope="col" class="col-lg-8">Questions</th>
                    <th scope="col" class="col-lg-4">Appréciations</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in form.item_lists" :key="index">
                    <td>{{ item.libelle }}</td>
                    <td>
                      <b-form-radio-group
                        v-model="item.reponse"
                        :options="reponses"
                      ></b-form-radio-group>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row mb-4 mt-2">
          <div class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-secondary mr-4"
              @click.prevent="
                $router
                  .push({
                    name: 'rh_formation_session_profil_evaluation',
                    params: {
                      profilId: currentProfil.id,
                      prov: prov,
                    },
                  })
                  .catch(() => {})
              "
            >
              Liste des évaluations
            </button>
            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Enregistrer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Form from 'vform';
import URL from '@/http/rh/formation/evaluation';
import DatePicker from 'vue2-datepicker';
export default {
  data() {
    return {
      form: new Form({
        date: this.$options.filters.formatDate(new Date(), 'DD/MM/YYYY'),
        checklist: '',
        item_lists: [],
      }),
      prov: this.$route.params.prov,
      checklists: [],
      itemListErrorMessage: null,
    };
  },
  computed: {
    ...mapGetters('profilParticipant', ['currentProfil', 'reponses']),
  },
  components: {
    DatePicker,
  },
  watch: {
    'form.checklist'() {
      this.form.item_lists = [];
      var checklist = window._.find(
        this.checklists,
        (chk) => chk.uuid === this.form.checklist
      );
      if (checklist) {
        this.form.item_lists = checklist.item_lists.map((item) => {
          return {
            question: item.uuid,
            libelle: item.libelle,
            reponse: 1,
          };
        });
      }
    },
  },
  methods: {
    init() {
      this.checklists = [];
      window.axios
        .get(
          URL.GET_REQUIREMENTS +
            '/' +
            this.currentProfil.session.formation.id +
            '/' +
            this.currentProfil.employe.id
        )
        .then((resp) => {
          this.checklists = resp.data.checklists;
        });
    },
    submit() {
      this.form.employe = this.currentProfil.employe.uuid;
      this.form.formation = this.currentProfil.session.formation.uuid;

      this.form
        .post(URL.EVALUATION)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          this.$router.push({
            name: 'rh_formation_session_profil_evaluation-show',
            params: {
              evaluationId: resp.data.evaluation.id,
              profilId: this.currentProfil.id,
              prov: this.prov,
            },
          });
        })
        .catch((err) => {
          this.form.errors.set('message', err.response.data.message);
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
